import Entities from 'STORE';

export function handleMaxParticipants(property) {
  Entities.Calls.setMaxParticipants(property?.value);
}
